/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateScheduleFilterSettings} from '../api'

export const useMutationUpdateScheduleFilterSettings = createReactQueryMutationHook('updateScheduleFilterSettings', updateScheduleFilterSettings)
